/* global MOBILE_BUILDER_URL */

import React from 'react';
import PropTypes from 'prop-types';
import {
  MenuSection,
  MoreMenu,
  ListRow,
  ExternalLink,
} from '@studio/legacy-components';
import PublishingActions from 'next/components/PublishingActions';
import { ContentStateShape } from 'next/lib/shapes';

import MobilePublishingManager from './MobilePublishingManager';

export default function SettingsHeaderActions({
  accountId,
  id,
  published,
  updatedAt,
  state,
}) {
  const builderUrl = `${MOBILE_BUILDER_URL}/flows/${id}?account=${accountId}`;
  const builderPreviewUrl = `${builderUrl}&preview=true`;

  return (
    <>
      <MobilePublishingManager id={id}>
        {({
          disabled,
          hasChanges,
          onConfirmPublish,
          onConfirmDiscardChanges,
          onConfirmUnpublish,
        }) => (
          <PublishingActions
            published={published}
            updatedAt={updatedAt}
            disabled={disabled}
            hasChanges={hasChanges}
            onConfirmPublish={onConfirmPublish}
            onConfirmDiscardChanges={onConfirmDiscardChanges}
            onConfirmUnpublish={onConfirmUnpublish}
          />
        )}
      </MobilePublishingManager>
      <MoreMenu>
        <MenuSection>
          <ListRow forwardedAs={ExternalLink} href={builderUrl} icon={false}>
            Open in Builder
          </ListRow>
          <ListRow
            forwardedAs={ExternalLink}
            href={builderPreviewUrl}
            icon={false}
          >
            View preview options
          </ListRow>
          {state === 'PUBLISHED' && <ListRow>Open permalink options</ListRow>}
        </MenuSection>
      </MoreMenu>
    </>
  );
}

SettingsHeaderActions.propTypes = {
  accountId: PropTypes.string,
  state: ContentStateShape,
  id: PropTypes.string,
  published: PropTypes.bool,
  updatedAt: PropTypes.number,
};
